import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as c from '../constant';
import * as action from '../action';
import IncentiveModal from '../modal/IncentiveModal';

function IncentiveContainer({ generateOVRSReport }) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    date_from: `${moment(new Date()).format('MM/DD/YYYY')}`,
    date_to: `${moment(new Date()).format('MM/DD/YYYY')}`,
  });
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const handleDateChange = key => ({ target: { value } }) => {
    if (
      key === 'date_from' &&
      `${moment(new Date(value)).format('YYYY/MM/DD')}` >
        `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning('Invalid filter, Date From is greater than Date To');

      setFormData({
        ...formData,
        [key]: '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleSubmit = e => {
    let args = {};
    if (
      `${moment(new Date(_.get(formData, 'date_from'))).format('YYYY/MM/DD')}` >
      `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning(
        'Invalid filter, Date From is greater than selected Date To'
      );
      setFormData({
        ...formData,
        date_from: '',
      });
    }

    if (
      _.get(formData, 'date_from') === '' ||
      _.get(formData, 'date_to') === ''
    ) {
      args = {
        ...formData,
      };
    }
    if (
      _.get(formData, 'date_from') !== '' ||
      _.get(formData, 'date_to') !== ''
    ) {
      args = {
        ...formData,
        date_from: `${moment(_.get(formData, 'date_from')).format(
          'YYYY-MM-DD'
        )}`,
        date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      };
    }

    e.preventDefault();
    const newData = {
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      type: args.ovrs_type,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
    };
    generateOVRSReport(newData, () => {
      setModal({
        isOpen: true,
        content: (
          <IncentiveModal
            date_from={args.date_from}
            date_to={args.date_to}
            ovrs_type={args.ovrs_type}
          />
        ),
        title: `Generated OVRS Report`,
        modalSize: 'modal-xl',
      });
    });
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="mb-5">
        <div className="row p-3">
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-2 px-1">
            <div className="form-input-group">
              <label className="label-reports">Module Type</label>
              <Select
                name="ovrs_type"
                placeholder="OVRS Type"
                onChange={handleChangeSelect('ovrs_type')}
                options={c.OVRS_TYPE}
                value={c.OVRS_TYPE.find(
                  item => item.value === _.get(formData, 'ovrs_type')
                )}
              />
            </div>
          </div>
          <div className="col-2 d-flex align-items-end px-1">
            <div className="form-input-group">
              <button
                disabled={
                  `${moment(new Date(_.get(formData, 'date_from'))).format(
                    'YYYY/MM/DD'
                  )}` >
                    `${moment(new Date(_.get(formData, 'date_to'))).format(
                      'YYYY/MM/DD'
                    )}` ||
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to')) ||
                  _.isEmpty(_.get(formData, 'ovrs_type'))
                }
                type="submit"
                className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary mb-1"
              >
                <i className="fas fa-download" /> &nbsp;&nbsp;Generate
              </button>
            </div>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}

IncentiveContainer.propTypes = {
  generateOVRSReport: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(IncentiveContainer);
